export var LoveRequestError;
(function (LoveRequestError) {
    LoveRequestError[LoveRequestError["DeviationNotFound"] = 0] = "DeviationNotFound";
    LoveRequestError[LoveRequestError["FolderNotFound"] = 2] = "FolderNotFound";
    LoveRequestError[LoveRequestError["DeviantBlockedYou"] = 5] = "DeviantBlockedYou";
    LoveRequestError[LoveRequestError["YourOwnDeviation"] = 6] = "YourOwnDeviation";
    LoveRequestError[LoveRequestError["CanNotBeLoved"] = 7] = "CanNotBeLoved";
})(LoveRequestError || (LoveRequestError = {}));
//# sourceMappingURL=types.js.map